import { arrayOf, bool, func, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Table, TableCell, TableRow } from "@components";
import { CircularProgress, Grid } from "@material-ui/core";
import { ContractorRow } from "./Rows/ContractorRow";
import useStyle from "./TeamTable.style";

export const ContractorsTable = observer(({
  contractors,
  isLoading,
  reloadData,
  useTableTitle,
}) => {
  const { t } = useTranslation();
  const classes = useStyle();

  return (
    <>
      {
        useTableTitle &&
        <Grid item container wrap="nowrap" className={classes.tableTitle}>
          <Grid item container alignItems="center">
            <h3 className={classes.title}>{t("views.team.contractors")}</h3>
          </Grid>
        </Grid>
      }

      {
        isLoading &&
        <CircularProgress
          aria-label="progress indicator"
          className={classes.spinner}
        />
      }
      {
        !isLoading &&
        <Table
          id="teamMembers"
          headers={[
            { label: t("views.team.name"), width: 320, flexible: true },
            { label: t("views.team.company"), width: 240 },
            { label: t("views.team.status"), width: 80 },
            { width: 34 },
          ]}
        >
          {
            contractors.map((u) => (
            <ContractorRow key={u.uuid} user={u} reloadData={reloadData} />
          ))
          }
          {
            !isLoading && !contractors.length &&
            <TableRow>
              <TableCell colSpan={7}>
                <h3>{t("views.team.not_found.contractors")}</h3>
              </TableCell>
            </TableRow>
          }
        </Table>
      }
    </>
  );
});

ContractorsTable.propTypes = {
  reloadData: func.isRequired,
  contractors: arrayOf(object).isRequired,
  isLoading: bool,
  useTableTitle: bool,
};
